import {GTS_FAILURE, GTS_PENDING, GTS_SUCCESS} from './constants'
import audit_63_items from '../../../fixtures/audit_63_items.json'

export async function getItems(params = {}, dispatch) {
  dispatch({type: GTS_PENDING})
  try {
    // let response = awitemsAPI(params)
    const response = audit_63_items

    dispatch({type: GTS_SUCCESS, payload: response})
  } catch (e) {
    console.log(`Get Items Failed`)
    dispatch({type: GTS_FAILURE, payload: e})
  }
}
